import { apiUrl2 } from '../../../settings'

export const getDraftApplicationsListUrl = () => {
  return apiUrl2 + '/canada-application-list'
}